import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';

import Config from '../../../config';

import getApi from '../../shared/apiFactory';
import agGridConfig from '../../../agGridConfig';
import columnHeaders from '../../clientAdministrationPage/bookToTaxCodeDescriptionTab/xlsxImport/columnHeaders';
import { FIELD_MAPPINGS, MAX_COLUMNS_NUMBER, MIN_COLUMNS_NUMBER } from '../../clientAdministrationPage/bookToTaxCodeDescriptionTab/xlsxImport/constants';
import { normalizeCellToString } from '../../../utils/readXlsxFile.utils';


export const sharedActions = getActions(adminPageNames.BOOK_TO_TAX_CODE_DESCRIPTIONS, {
  pageTitle: adminPageTitles.BOOK_TO_TAX_CODE_DESCRIPTIONS,
  api: getApi({
    pageTitle: adminPageTitles.BOOK_TO_TAX_CODE_DESCRIPTIONS,
    endpoints: {
      FETCH: Config.endpoints.FETCH_BOOK_TO_TAX_CODE_DESCRIPTIONS,
      INSERT: Config.endpoints.ADD_BOOK_TO_TAX_CODE_DESCRIPTION,
      UPDATE: Config.endpoints.UPDATE_BOOK_TO_TAX_CODE_DESCRIPTION,
      DELETE: Config.endpoints.REMOVE_BOOK_TO_TAX_CODE_DESCRIPTION,
      VALIDATE: Config.endpoints.VALIDATE_BOOK_TO_TAX_CODE_DESCRIPTIONS,
      IMPORT: Config.endpoints.IMPORT_BOOK_TO_TAX_CODE_DESCRIPTIONS,
    },
  }),
  sortingField: 'tagCode',
  agGridConfig: agGridConfig.adminClientAdministrationBookToTaxCodes,
  decodeCountryTaxType: false,
  excel: {
    sheetName: 'Book To Tax Code Descriptions',
    lastColumnLetter: 'H',
    columnHeaders,
    fieldMappings: FIELD_MAPPINGS,
    fieldNormalizers: {
      tagcode: normalizeCellToString,
    },
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,
  },
});
